var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
import { Service } from '~/core/service';
var OutsourceSettleManageService = /** @class */ (function (_super) {
    __extends(OutsourceSettleManageService, _super);
    function OutsourceSettleManageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 结清案件池
     */
    OutsourceSettleManageService.prototype.getCaseSettlePoolPageList = function (params, page, sort) {
        return this.netService.send({
            server: domainService.outsourceSettleManageController.getCaseSettlePoolPageList,
            data: {
                outBatch: params.outBatch,
                caseNumber: params.caseNumber,
                personalName: params.personalName,
                mobileNo: params.mobileNo,
                idCard: params.idCard,
                area: params.area,
                customerCategory: params.customerCategory,
                outAmountMax: params.outAmount ? params.outAmount.max : '',
                outAmountMin: params.outAmount ? params.outAmount.min : '',
                overduePeriod: params.overduePeriod,
                overdueDaysMax: params.overdueDays ? params.overdueDays.max : '',
                overdueDaysMin: params.overdueDays ? params.overdueDays.min : '',
                currentCollector: params.currentCollector,
                followupBack: params.followupBack,
                turnSource: params.turnSource,
                productCategory: params.productCategory,
                productName: params.productName,
                followInTimeMax: FilterService.dateRanageFormat(params.followInTime).end,
                followInTimeMin: FilterService.dateRanageFormat(params.followInTime).start,
                outId: params.outName,
                collectionStatus: 'OUTER_PAYOFF',
                labelName: params.labelName,
                caseMoneyMin: params.caseMoney ? params.caseMoney.min : '',
                caseMoneyMax: params.caseMoney ? params.caseMoney.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceSettleManageService.prototype, "netService", void 0);
    return OutsourceSettleManageService;
}(Service));
export { OutsourceSettleManageService };
